<!-- Main container -->
<div class="register-container">
  <!-- Header container -->
  <app-logo />
  <!-- Main content container -->
  <div class="register-content-container">
    <h1 class="register-content-container__title">
      {{ 'registerApp_titleWelcome' | translate }}
      @if (env.isRoyalCanin) {
        <span class="red__markup">{{ 'registerApp_titleRC' | translate }}</span>
      } @else {
        <span class="red__markup">{{
          env.getTranslationPrefix() + 'registerApp_title' | translate
        }}</span>
      }
    </h1>
    <div class="register-content-container__subtitle-container">
      <span
        >{{ 'registerApp_subtitleSecondLine' | translate }}&nbsp;<a
          id="registerGoToLogin"
          (click)="goToLogin()"
          class="rc-link hyperlink"
          appTracking="registration.loginClick"
          >{{ 'registerApp_login' | translate }}</a
        ></span
      >
    </div>
    <app-register-page-form></app-register-page-form>
  </div>
</div>
